import type { TFunction } from 'i18next';
import { ExternalService } from '../../../../api/integrations-client/integrations-client.type';
import type { FilterGroup as BaseFilterGroup } from '../../../../components/filters/filter-panel.type';
import { Status } from '../../strategy.type';

type FilterGroup = BaseFilterGroup & {
  id: string;
};

const SOURCE_LABELS = {
  [ExternalService.Jira]: 'Atlassian Jira Software Cloud',
  [ExternalService.JDC]: 'Atlassian Jira Data Center',
  [ExternalService.ADO]: 'Microsoft Azure',
  [ExternalService.Github]: 'GitHub',
};

/**
 * Build the initiative status → display label map against the caller's
 * translation function so org-level text_config overrides apply. Returns a
 * partial map because Status.Empty has no label (no UI surface displays it).
 *
 * @param {TFunction} t - Translation function from `useTranslation()`
 * @returns Partial status label map keyed by Status enum value
 */
const getStatusLabels = (t: TFunction) => ({
  [Status.OnTrack]: t('strategy.initiatives.statuses.on_track'),
  [Status.AtRisk]: t('strategy.initiatives.statuses.at_risk'),
  [Status.OffTrack]: t('strategy.initiatives.statuses.off_track'),
  [Status.Unknown]: t('strategy.initiatives.statuses.unknown'),
});

export { getStatusLabels, SOURCE_LABELS };
export type { FilterGroup };
